import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const SunIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 59.991 59.96',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path
      fill="currentColor"
      d="M-133.212,1211.782a19.98,19.98,0,0,1-19.933-19.985,19.937,19.937,0,0,1,19.959-19.885A19.924,19.924,0,0,1-113.27,1191.9,19.965,19.965,0,0,1-133.212,1211.782Zm17.6-19.957a17.6,17.6,0,0,0-17.595-17.572,17.572,17.572,0,0,0-17.584,17.517,17.6,17.6,0,0,0,17.605,17.654A17.6,17.6,0,0,0-115.616,1191.825Z"
      transform="translate(163.227 -1161.854)"
    />
    <path
      fill="currentColor"
      d="M-160.2,1354.9a5.11,5.11,0,0,1-.921-.739.955.955,0,0,1,.041-1.178,1.858,1.858,0,0,1,.218-.276c1.034-1.038,2.061-2.085,3.111-3.107a1.176,1.176,0,0,1,2.014.483,1.047,1.047,0,0,1-.3,1.108q-1.624,1.663-3.29,3.284A3.561,3.561,0,0,1-160.2,1354.9Z"
      transform="translate(169.738 -1303.271)"
    />
    <path
      fill="currentColor"
      d="M28.429,1354.879a3.329,3.329,0,0,1-.815-.432c-1.079-1.04-2.136-2.1-3.186-3.173a1.122,1.122,0,0,1-.042-1.7,1.194,1.194,0,0,1,1.715.066q1.566,1.542,3.109,3.108a1.143,1.143,0,0,1,.317,1.333A1.3,1.3,0,0,1,28.429,1354.879Z"
      transform="translate(21.922 -1303.291)"
    />
    <path
      fill="currentColor"
      d="M29.618,1165.207a3.143,3.143,0,0,1-.431.729c-1.029,1.066-2.082,2.107-3.137,3.147a1.169,1.169,0,0,1-1.638.09,1.089,1.089,0,0,1-.084-1.657c1.08-1.133,2.2-2.232,3.317-3.323a1.081,1.081,0,0,1,1.269-.183A1.279,1.279,0,0,1,29.618,1165.207Z"
      transform="translate(21.945 -1155.452)"
    />
    <path
      fill="currentColor"
      d="M-160,1163.593a3.539,3.539,0,0,1,.81.448c1.054,1.018,2.088,2.057,3.113,3.105a1.14,1.14,0,0,1,.063,1.743,1.2,1.2,0,0,1-1.749-.117q-1.541-1.532-3.072-3.074a1.114,1.114,0,0,1-.283-1.336A1.305,1.305,0,0,1-160,1163.593Z"
      transform="translate(169.68 -1155.219)"
    />
    <path
      fill="currentColor"
      d="M-58.187,1387.833c0,.724,0,1.447,0,2.171a1.166,1.166,0,0,1-1.152,1.262,1.16,1.16,0,0,1-1.177-1.236q-.008-2.222,0-4.444a1.137,1.137,0,0,1,1.177-1.224,1.143,1.143,0,0,1,1.153,1.248C-58.184,1386.351-58.187,1387.092-58.187,1387.833Z"
      transform="translate(89.349 -1331.306)"
    />
    <path
      fill="currentColor"
      d="M-199.492,1266.834c-.724,0-1.448.007-2.172,0a1.18,1.18,0,0,1-1.289-1.131,1.22,1.22,0,0,1,1.289-1.2c.925-.021,1.852-.005,2.778-.005.539,0,1.078-.016,1.616.005a1.223,1.223,0,0,1,1.266,1.173,1.2,1.2,0,0,1-1.316,1.158C-198.044,1266.84-198.768,1266.834-199.492,1266.834Z"
      transform="translate(202.953 -1235.694)"
    />
    <path
      fill="currentColor"
      d="M62.591,1266.835c-.724,0-1.448.007-2.172,0a1.191,1.191,0,0,1-1.3-1.123A1.219,1.219,0,0,1,60.4,1264.5c.808-.022,1.616-.005,2.424-.005.623,0,1.246-.007,1.869,0a1.243,1.243,0,0,1,1.374,1.169c0,.7-.525,1.159-1.356,1.166C64.005,1266.84,63.3,1266.835,62.591,1266.835Z"
      transform="translate(-6.077 -1235.695)"
    />
    <path
      fill="currentColor"
      d="M-58.188,1125.7c0,.741.005,1.481,0,2.222a1.173,1.173,0,0,1-1.147,1.221,1.17,1.17,0,0,1-1.181-1.237q-.008-2.222,0-4.444a1.172,1.172,0,0,1,1.173-1.242,1.177,1.177,0,0,1,1.157,1.258C-58.184,1124.214-58.188,1124.955-58.188,1125.7Z"
      transform="translate(89.349 -1122.216)"
    />
    <path
      fill="currentColor"
      d="M-74.95,1275.4c-2.246-.066-3.96-.833-4.961-2.8a1.89,1.89,0,0,1-.192-1,1.036,1.036,0,0,1,.989-.918,1.047,1.047,0,0,1,1.158.623c.653,1.857,3.145,2.041,4.487,1.421a2.442,2.442,0,0,0,1.247-1.263,1.161,1.161,0,0,1,1.557-.7,1.168,1.168,0,0,1,.581,1.612,4.857,4.857,0,0,1-3.79,2.912C-74.269,1275.348-74.674,1275.367-74.95,1275.4Z"
      transform="translate(104.973 -1236.547)"
    />
    <path
      fill="currentColor"
      d="M-24.294,1240.747a1.174,1.174,0,0,1-1.086,1.327,1.2,1.2,0,0,1-1.262-1.171.851.851,0,0,0-.841-.836.846.846,0,0,0-.9.821c-.119.794-.641,1.268-1.3,1.18a1.219,1.219,0,0,1-1.047-1.506,3.275,3.275,0,0,1,3.284-2.88A3.219,3.219,0,0,1-24.294,1240.747Z"
      transform="translate(65.599 -1213.243)"
    />
    <path
      fill="currentColor"
      d="M-110,1240.807a3.276,3.276,0,0,1,2.028-2.836,3.24,3.24,0,0,1,3.421.655,3.169,3.169,0,0,1,1.019,2.29,1.2,1.2,0,0,1-1.119,1.213,1.153,1.153,0,0,1-1.22-1.089c-.081-.628-.386-.945-.907-.942a.876.876,0,0,0-.888.851c-.1.768-.587,1.236-1.235,1.179A1.2,1.2,0,0,1-110,1240.807Z"
      transform="translate(128.812 -1213.296)"
    />
  </SvgIcon>
);

export default SunIcon;
